import { render, staticRenderFns } from "./TabAktivitas.vue?vue&type=template&id=794c4fc4&scoped=true&lang=html&"
import script from "./TabAktivitas.vue?vue&type=script&lang=js&"
export * from "./TabAktivitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c4fc4",
  null
  
)

export default component.exports